export default "__VITE_ASSET__BfKrm_F3__"